export default __webpack_public_path__ + "static/media/330_business04-en-web.81dbca96.png";